import React from 'react'

import logo from '../images/BLACK1.webp'
import footer from '../images/footer_logo.png'


//icons

import { FaSquareXTwitter } from "react-icons/fa6";
import { BsInstagram } from "react-icons/bs";
import { FiFacebook } from "react-icons/fi";
import { RiYoutubeLine } from "react-icons/ri";
import { TbBrandWhatsapp } from "react-icons/tb";
import { MdOutlinePhoneAndroid } from "react-icons/md";
import { BiWorld } from "react-icons/bi";
import { TbDeviceLandlinePhone } from "react-icons/tb";
import { FaThreads } from "react-icons/fa6";

import { MdMailOutline } from "react-icons/md";


import { FaMobileScreen } from "react-icons/fa6";
import { Link } from 'react-router-dom';


const Footer = () => {
  return (
    <div>

      <div className='w-full font-[poppins]'>

        <div class="bg-[#fbfbfb] font-[poppins] rounded-t-md pt-4 md:pt-8">
          <div class="px-6  w-full  md:w-[85%] mx-auto md:px-4 sm:px-6 text-gray-800 sm:grid md:grid-cols-3 sm:grid-cols-2 gap-x-20">

            <div class=" p-3 md:p-5">
              <img src={footer} className=' w-28 sm:w-32 md:w-44 opacity-90 object-cover drop-shadow-lg' alt="" />


              <div className='flex items-center gap-x-6 md:gap-x-8 mt-2'>
                <section class="flex justify-center items-center">
                  <Link to='https://www.facebook.com/profile.php?id=61559751436051' target='_blank'>
                    <button
                      class="group flex justify-center p-2 rounded-md drop-shadow-xl bg-gray-900 text-white font-semibold hover:translate-y-3 hover:rounded-[50%] transition-all duration-500 hover:from-[#331029] hover:to-[#310413]"
                    >
                      <FiFacebook className="text-[12px] sm:text-[14px]" />
                      <span
                        class="absolute opacity-0 group-hover:opacity-100 group-hover:text-gray-700 group-hover:text-sm group-hover:-translate-y-10 duration-700"
                      >
                        <p className=' text-[10px] md:text-[12px]'>Facebook</p>
                      </span>
                    </button>
                  </Link>
                </section>
                <section class="flex justify-center items-center">
                  <Link to="https://www.instagram.com/cinema_factory_academy?igsh=MWY1bXRzcXdwdzFh" target='_blank'>
                    <button

                      class="group flex justify-center p-2 rounded-md drop-shadow-xl bg-gray-900  text-white font-semibold hover:translate-y-3 hover:rounded-[50%] transition-all duration-500 hover:from-[#331029] hover:to-[#310413]"
                    >
                      <BsInstagram className="text-[12px] sm:text-[14px]" />
                      <span
                        class="absolute opacity-0 group-hover:opacity-100 group-hover:text-gray-700 group-hover:text-sm group-hover:-translate-y-12 duration-700 text-[14px] md:text-[16px]"
                      >
                        <p className=' text-[10px] md:text-[12px]'>Instagram</p>
                      </span>
                    </button>
                  </Link>
                </section>
                <section class="flex justify-center items-center">
                  <Link to='https://x.com/CF_academy2024?t=50Xz_jo1R8-TMc3gVJnwwQ&s=09' target='_blank'>
                    <button
                      href="/"
                      class="group flex justify-center p-2 rounded-md drop-shadow-xl bg-gray-900 from-gray-800 to-black text-white font-semibold hover:translate-y-3 hover:rounded-[50%] transition-all duration-500 hover:from-[#331029] hover:to-[#310413]"
                    >
                      <FaSquareXTwitter className="text-[12px] sm:text-[14px]" />
                      <span
                        class="absolute opacity-0 group-hover:opacity-100 group-hover:text-gray-700 group-hover:text-sm group-hover:-translate-y-10 duration-700 text-[14px] md:text-[16px]"
                      >
                        <p className=' text-[10px] md:text-[12px]'>Twitter</p>
                      </span>
                    </button>
                  </Link>
                </section>
                <section class="flex justify-center items-center">
                  <Link to="https://www.threads.net/@cinema_factory_academy" target='_blank'>
                    <button
                      class="group flex justify-center p-2 rounded-md drop-shadow-xl bg-gray-900 from-gray-800 to-black text-white font-semibold hover:translate-y-3 hover:rounded-[50%] transition-all duration-500 hover:from-[#331029] hover:to-[#310413]"
                    >
                      <FaThreads className="text-[12px] sm:text-[14px]" />
                      <span
                        class="absolute opacity-0 group-hover:opacity-100 group-hover:text-gray-700 group-hover:text-sm group-hover:-translate-y-10 duration-700 text-[14px] md:text-[16px]"
                      >
                        <p className=' text-[10px] md:text-[12px]'>Youtube</p>
                      </span>
                    </button>
                  </Link>
                </section>
                <section class="flex justify-center items-center">
                  <Link to="https://api.whatsapp.com/send?phone=9884683888" target='_blank' className="">
                    <button
                      class="group flex justify-center p-2 rounded-md drop-shadow-xl bg-gray-900 from-gray-800 to-black text-white font-semibold hover:translate-y-3 hover:rounded-[50%] transition-all duration-500 hover:from-[#331029] hover:to-[#310413]"
                    >
                      <TbBrandWhatsapp className="text-[12px] sm:text-[14px]" />
                      <span
                        class="absolute opacity-0 group-hover:opacity-100 group-hover:text-gray-700 group-hover:text-sm group-hover:-translate-y-10 duration-700 text-[14px] md:text-[16px]"
                      >
                        <p className=' text-[10px] md:text-[12px]'>Whatsapp</p>
                      </span>
                    </button>
                  </Link>
                </section>
              </div>
            </div>

            <div class="p-3 md:p-5 font-[poppins]">
              <div class="text-[14px] sm:text-[15px] md:text-[16px]  uppercase text-gray-900 font-bold"> Courses</div>
              <Link class="text-gray-800 my-3 block  text-[12px] sm:text-[13px]  md:text-[14px] " to="https://direction.cinemafactory.co.in/" target='_blank'>Direction </Link>
              <Link class="text-gray-800 my-3 block  text-[12px] sm:text-[13px]  md:text-[14px] " to="https://cinematography.cinemafactory.co.in/" target='_blank'>Cinematography </Link>
              <Link class="text-gray-800 my-3 block  text-[12px] sm:text-[13px]  md:text-[14px] " to="https://vfx.cinemafactory.co.in/" target='_blank'>CG & VFX</Link>
              <Link class="text-gray-800 my-3 block  text-[12px] sm:text-[13px]  md:text-[14px] " to="https://editing.cinemafactory.co.in/" target='_blank'>Editing</Link>
              <Link class="text-gray-800 my-3 block  text-[12px] sm:text-[13px]  md:text-[14px] " to="https://acting.cinemafactory.co.in/" target='_blank'>Acting</Link>
            </div>

            <div class="p-3 md:p-5">
              <div class="text-[14px] sm:text-[15px] md:text-[16px]  uppercase text-gray-900 font-bold">Contact us</div>
              <h3 className='capitalize text-[12px] sm:text-[14px] md:text-[14px] my-3 font-bold '>BigBay Cinema Factory Private Ltd</h3>

              <p class="text-gray-800 my-3 block  text-[12px] sm:text-[13px]  md:text-[14px]">No.271A, 3rd Floor, Maan Sarovar Tower, Scheme Road, Teynampet, Chennai - 600018 India</p>
              <p className='text-[12px] md:text-[14px] my-3 flex items-center gap-x-2 '><MdMailOutline className='text-[20px] font-bold' /> contact@cinemafactory.co.in</p>
              <p className='text-[12px] md:text-[14px] my-3 flex items-center gap-x-2 '><MdOutlinePhoneAndroid className='text-[20px] font-bold' /> +91 9884683888</p>
              <p className='text-[12px] md:text-[14px] my-3 flex items-center gap-x-2 '><MdOutlinePhoneAndroid className='text-[20px] font-bold' /> +91 9884428688</p>
              <p className='text-[12px] md:text-[14px] my-3 flex items-center gap-x-2 '><TbDeviceLandlinePhone className='text-[20px] font-bold' /> +91 44 24815365</p>

            </div>

          </div>
        </div>



        <div class="bg-[#fbfbfb] md:pt-2">
          <div class="flex justify-center pb-2 md:pb-5 px-3 m-auto pt-2 md:pt-5 border-t text-gray-800 text-sm  w-[80%]  items-center">

            <div class=" my-2 md:my-5 text-[10px] sm:text-[12px] md:text-[14px] text-gray-800"> © Vishnu Ads and Ventures 2024. All Rights Reserved.</div>

          </div>
        </div>
      </div>

    </div >
  )
}

export default Footer
